import { ParsedDate } from '../parsed/parsedDate';
import { SessionLocation } from './sessionLocation';
import { z } from 'zod';

export const BasketItemMetaData = z.object({
    correlationGuid: z.string(),
    actualWeight: z.number().nullish(),
    expectedWeight: z.number().nullish(),
    location: SessionLocation.nullish(),
    oldAmount: z.number().nullish(),
    newAmount: z.number().nullish(),
    changeSource: z.string().nullish(),
    createdOn: ParsedDate.nullish(),
    images: z.string().array().nullish(),
});
export type BasketItemMetaData = z.infer<typeof BasketItemMetaData>;
